import React, { useEffect, useState } from 'react'
import "./styles.css";
import DialCodePicker, { CountryCodeData } from 'components/dialCodePicker';
import { ResetPassword, SignInForm } from 'common/features/auth/AuthModels';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { validateField } from 'common/utils/field-validator';
import {resetPasswordRequest } from 'common/features/auth/AuthActions';
import { RootState } from 'common/rootReducer';
export interface AuthForgotPasswordInterface {
  handleOnPageSwitch:(key:string)=>void;
  handleOnSuccess:(key:string,data:any)=>void;
  }

const AuthForgotPassword = (props:AuthForgotPasswordInterface) => {

    const dispatch = useDispatch();

    const {handleOnPageSwitch,handleOnSuccess} = props;

    const [showDialCodePicker, setShowDialCodePicker] = useState(false);
    const [countryData, setCountryData] = useState<CountryCodeData>({
        code: "+1",
        flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
      });
      const [mobilePhone, setUserId] = useState("");
      const [payloadData, setPayloadData] = useState<any>(null);

      const resetPasswordMessage = useSelector( (state: RootState) => state.auth.resetPasswordMessage );
      const resetPasswordLoading = useSelector( (state: RootState) => state.auth.resetPasswordLoading );
      const resetPasswordInitiateSuccess = useSelector( (state: RootState) => state.auth.resetPasswordInitiateSuccess );

      const [errMsg,setErrMsg] = useState('')

    const {register,errors,handleSubmit,control,getValues,setValue,watch, formState,} = useForm<ResetPassword>({defaultValues: {mobilePhone: ""},});

    useEffect(() => {
      if (resetPasswordInitiateSuccess && !resetPasswordLoading && formState.isSubmitted) {
        handleOnSuccess('FORGOT_PASSWORD_OTP',payloadData)
      }
    }, [resetPasswordLoading]);

    useEffect(() => {
      setErrMsg(resetPasswordMessage)
    }, [resetPasswordMessage])
    
    
    const onSubmit = (data: ResetPassword) => {
      const payload = {
          mobilePhone: countryData.code + "-" + data.mobilePhone,
          sendOtp: 1,
          password: "",
        }
      setPayloadData(payload)
      dispatch(resetPasswordRequest(payload)  );
    };

  return (
    <React.Fragment>
        <div id="sign-in-screen">

            <form id="sign-in-form" onChange={()=>setErrMsg('')} onSubmit={handleSubmit(onSubmit)}>
           
                <div id="title-container-ad">
                  <span id="reset-info">
                    Enter your registered phone number <br />
                    
                  </span>
                </div>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label id="input-label">User ID</label>
                    <div id="signIn-text-box" style={{ marginTop: "0.5rem" }}>
                        <React.Fragment>
                        <img
                            alt="flag"
                            src={countryData.flag}
                            height={"14px"}
                            width={"21px"}
                            className="flag"
                            onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                        />
                        &nbsp;
                        <span id="countryCode" onClick={() => setShowDialCodePicker(!showDialCodePicker)} >
                            {countryData.code}
                        </span>
                        </React.Fragment>
                        <input
                            type="text"
                            placeholder="Enter Mobile number"
                            name="mobilePhone"
                            ref={register(validateField("userId").isValidMobileNumber().isRequired().Rules)}
                            maxLength={10}
                            //onChange={(event) => {
                            // const validatedValue = event.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                            // setUserId(validatedValue);                      
                            // }}
                            //value={mobilePhone} 
                            autoComplete="off"
                            className="mobile-detail"
                        />
                    </div>
                    <span id="error-msg">
                        {errors.mobilePhone && errors.mobilePhone.type === "required" && (
                            <span className="req-msg">User ID Required</span>
                        )}
                         {errors.mobilePhone && errors.mobilePhone.type === "pattern" && (
                            <span className="req-msg">Enter a Valid Mobile Number</span>
                        )}
                    </span>
                    <DialCodePicker
                      showPicker={showDialCodePicker}
                      setShowPicker={setShowDialCodePicker}
                      setCountryData={setCountryData}
                      inputValue={mobilePhone}
                      setIsMobile={()=>{}}
                      onlyMobile={false}
                    />
                </div>


                <div id="links-container">
                    <span className="sign-up-form-error-msg desktop-login-form-error-msg"  style={{ marginBottom: "15px"}} > {errMsg.length > 0 ? errMsg : null} </span>
                    <button id="sign-in-button-ad"  type="submit"  style={{ width: 305 }}> 
                      {resetPasswordLoading ? "Validating" : "Send OTP"}
                    </button>
                </div>
            </form>
        </div>
    </React.Fragment>
  )
}

export default AuthForgotPassword